module.exports = __webpack_public_path__ + "img/arte2.a1579662.png";